// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1yjaI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3vaBN"};